import React from "react";
import { useSelector } from "react-redux";
import pluralize from "@tvg/utils/generalUtils";
import formatCurrency from "@tvg/formatter/currency";
import { Paragraph, Button } from "@tvg/design-system";
import { TextContainer } from "./styled-components";
import { getBetSlipDisabledSelectionsLabel } from "../../../../store/selectors";

export interface PlaceBetButtonProps {
  onClickPlaceBet: (totalBetAmount: number) => void;
  placeAmount: number;
  remainingSelections: number;
  approxPayout: string;
  isLoading: boolean;
  isLeg?: boolean;
  isDisabled?: boolean;
}

const PlaceBetButton = ({
  onClickPlaceBet,
  placeAmount,
  remainingSelections,
  approxPayout,
  isLoading,
  isLeg,
  isDisabled = false
}: PlaceBetButtonProps) => {
  const isMissingLegSelection = isLeg && remainingSelections > 0;
  const disabledMessage = isMissingLegSelection
    ? `${pluralize(remainingSelections, "Leg", false)} Remaining`
    : useSelector(getBetSlipDisabledSelectionsLabel);

  return (
    <Button
      ml="space-4"
      variant="betting"
      onPress={() => onClickPlaceBet(placeAmount)}
      isLoading={isLoading}
      isDisabled={isDisabled || placeAmount === 0}
      qaLabel="bet-slip-place-bet-button"
    >
      <TextContainer>
        {isMissingLegSelection && (
          <Paragraph
            fontFamily="bold"
            fontSize="s"
            color="white.900"
            qaLabel="bet-slip-remaining-selections-text"
          >
            {`${remainingSelections}`}
          </Paragraph>
        )}
        <Paragraph
          fontFamily={isMissingLegSelection ? "regular" : "bold"}
          fontSize={isMissingLegSelection ? "xs" : "s"}
          textTransform={isMissingLegSelection ? "uppercase" : "none"}
          color="white.900"
          qaLabel="bet-slip-amount-text"
        >
          {placeAmount === 0
            ? disabledMessage
            : `Place ${formatCurrency(placeAmount)} Bet`}
        </Paragraph>
        {approxPayout !== "0" && (
          <Paragraph
            fontFamily="condensedRegular"
            fontSize="xs"
            textTransform="uppercase"
            color="white.900"
            qaLabel="bet-slip-approxPayout-text"
          >
            {`Approx. Pay - ${approxPayout}`}
          </Paragraph>
        )}
      </TextContainer>
    </Button>
  );
};

export default PlaceBetButton;
